// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic_heading {
  color: #aaa;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: 20px;
  margin-left: 6px;
}

.dynamic_formContainer {
  width: 100%;
  min-width: 800px;
  /* max-width: 800px !important; */
  /* padding-top: auto;
  padding-bottom: auto; */
  height: 100vh;
  padding-bottom: 100px;
  padding-left: 20%;
  padding-right: 20%;
  /* margin: auto; */
  overflow: auto;
}

.dynamic_formCompulsory{
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  color: #6C6060;
}

.dynamic_formModal {
  width: 100%;
  height: 100%;
  /* max-width: 750px; */
  max-height: 84vh;
  overflow: auto;
  padding: 0 15px;
  background-color: #fbfcff;
}

.dynamic_section {
  border-radius: 8px 8px 8px 8px;
  width: 100%;
  border: 0.5px solid #dcdcdc;
  color: #dcdcdc;
}

.dynamic_AddNewCustomer {
  border-radius: 8px;
  border: none;
  background: #ffd705;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  padding: 11px 100px;
  color: black;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_sectionHeader {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: #eaf2ff;
  /* border-radius: 8px 8px 0px 0px;
border: 0.5px solid #DCDCDC;
background: rgba(85, 153, 255, 0.10); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #aeaeae;
  /* height: 40px; */
  padding: 5px 20px;
  position: relative;
}

.dynamic_sectionHeaderMoreOption {
  position: absolute;
  top: 75%;
  right: 2%;
  border-radius: 8px;
  border: 0.6px solid #5599ff;
  background-color: #f8fafc;
  color: black;
  text-align: center;
  /* padding: 2rem; */
  z-index: 1;
}

.dynamic_sectionHeaderMoreOption div:hover {
  background-color: #dee7ff;
  border-radius: 8px;
}

.dynamic_sectionHeader input {
  background-color: transparent;
  width: 40%;
  border-radius: 8px;
  border: 0.4px solid #b5d3ff;
  padding: 8px 10px 8px 10px;
  color: #aeaeae;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_sectionContent {
  padding: 10px 20px;
  background-color: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.dynamic_container {
  position: relative;
}

.dynamic_isPreviewing {
  margin: 5px 0;
}

.dynamic_plusButton {
  height: 16px;
  width: 16px;
  background-color: #cde1ff;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dynamic_field {
  border-radius: 8px;
  border: 0.5px solid #dcdcdc;
  background: #fff;
  padding: 6px 15px;
  color: #303030;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_createContainer {
  width: 100%;
  padding: 8px 50%;
  border-radius: 8px;
  border: 1px dashed #e9e9e9;
  background-color: white;
}

.dynamic_createContainer div,
.dynamic_containerPlus {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #e9e9e9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dynamic_createContainer:hover {
  border-color: #5599ff;
  cursor: pointer;
}

.dynamic_createContainer:hover div{
  background-color: #5599ff;
  border-radius: 50%;
}

.dynamic_selectedFields {
  border-radius: 8px;
  border: 0.5px solid #dcdcdc;
  background: #fff;
  padding: 10px;
}

.dynamic_fieldSearchInput {
  border-radius: 8px;
  padding: 8px 15px;
  border: 0.4px solid #dcdcdc;
  background: #fafafa;
  color: #6c6c6c;

  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_fieldSearchedValues {
  padding: 8px 15px;
  color: #6c6c6c;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_divider {
  background: #f2f2f2;
  height: 0.5px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.dynamic_fieldList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 12px 15px;
  border: 0.5px solid #dcdcdc;
  background: #fff;
  color: #303030;
  margin-bottom: 10px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_isCheckedFieldList {
  border-color: #5599ff;
}

.dynamic_fieldType {
  color: #c0c0c0;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}

.dynamic_switch {
  margin-left: 20px;
  margin-right: 60px;
  position: relative;
  display: inline-block;
  width: 26px;
  height: 14px;
  padding: 0;
}

.dynamic_switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.dynamic_slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.dynamic_slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 3px;
  bottom: 4px;
  top: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .dynamic_slider {
  background-color: #55e374;
}

input:focus + .dynamic_slider {
  box-shadow: 0 0 1px #55e374;
}

input:checked + .dynamic_slider:before {
  transform: translateX(11px);
}

/* Rounded dynamic_sliders */
.dynamic_slider.dynamic_round {
  border-radius: 20px;
}

.dynamic_slider.dynamic_round:before {
  border-radius: 50%;
}

.dynamic_checkbox {
  display: block;
  position: relative;
  padding-left: 20px;
  margin-bottom: 12px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.dynamic_checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.dynamic_checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.dynamic_checkbox:hover input ~ .dynamic_checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.dynamic_checkbox input:checked ~ .dynamic_checkmark {
  background-color: #548dff;
}

/* Create the dynamic_checkmark/indicator (hidden when not checked) */
.dynamic_checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the dynamic_checkmark when checked */
.dynamic_checkbox input:checked ~ .dynamic_checkmark:after {
  display: block;
}

/* Style the dynamic_checkmark/indicator */
.dynamic_checkbox .dynamic_checkmark:after {
  left: 5.5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.dynamic_blueButton {
  border-radius: 8px;
  border: none;
  background: #548dff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  padding: 11px 30px;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.dynamic_blueButton:hover {
  background-color: #4e82ec;
}

.dynamicDropDown_style {
  
}

.dynamic_borderButton {
  border-radius: 8px;
  border: 1px solid #548dff;
  background: #fff;
  /* box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16); */
  color: #548dff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.dynamic_borderButton:hover {
  background-color: #eff6ff;
}

.dynamic_createContainerLine {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dynamic_containerDivider,
.dynamic_containerPlus {
  transition: background-color 0.3s, border-color 0.3s;
}

.dynamic_containerDivider {
  border: 1px dashed #e9e9e9;
}

.dynamic_createContainerLine:hover .dynamic_containerDivider,
.dynamic_createContainerLine:hover .dynamic_containerPlus {
  border-color: #5599ff;
  background-color: #5599ff;
}

.dynamic_containerPlus:hover,
.dynamic_createContainerLine:hover .dynamic_containerPlus {
  background-color: #5599ff;
}

.dynamic_containerDivider:hover,
.dynamic_createContainerLine:hover .dynamic_containerDivider {
  border-color: #5599ff;
}


/* .dynamic_containerDivider {
  border: 1px dashed #e9e9e9;
} */

.dynamic_leftOneDivider {
  width: 51%;
}

.dynamic_rightOneDivider {
  width: 49%;
}

/* .dynamic_containerDivider:hover, .dynamic_containerPlus:hover {
  border-color: #5599ff;
  background-color: #5599ff;
  cursor: pointer;
} */

/* .dynamic_containerPlus:hover {
  background-color: #5599ff;
  cursor: pointer;
} */

.widthThirtyThree {
  width: 33.33%;
}

.backgroundDisabled {
  background-color: #e9e9e9;
}

.marginRightSixPx {
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/DynamicForm/dynamicForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;yBACuB;EACvB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB;;uCAEqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;;EAEd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,QAAQ;EACR,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;AAC3B;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;;AAGA;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;GAIG;;AAEH;;;GAGG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".dynamic_heading {\n  color: #aaa;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  margin-top: 20px;\n  margin-left: 6px;\n}\n\n.dynamic_formContainer {\n  width: 100%;\n  min-width: 800px;\n  /* max-width: 800px !important; */\n  /* padding-top: auto;\n  padding-bottom: auto; */\n  height: 100vh;\n  padding-bottom: 100px;\n  padding-left: 20%;\n  padding-right: 20%;\n  /* margin: auto; */\n  overflow: auto;\n}\n\n.dynamic_formCompulsory{\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 12px;\n  color: #6C6060;\n}\n\n.dynamic_formModal {\n  width: 100%;\n  height: 100%;\n  /* max-width: 750px; */\n  max-height: 84vh;\n  overflow: auto;\n  padding: 0 15px;\n  background-color: #fbfcff;\n}\n\n.dynamic_section {\n  border-radius: 8px 8px 8px 8px;\n  width: 100%;\n  border: 0.5px solid #dcdcdc;\n  color: #dcdcdc;\n}\n\n.dynamic_AddNewCustomer {\n  border-radius: 8px;\n  border: none;\n  background: #ffd705;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n  padding: 11px 100px;\n  color: black;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_sectionHeader {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-color: #eaf2ff;\n  /* border-radius: 8px 8px 0px 0px;\nborder: 0.5px solid #DCDCDC;\nbackground: rgba(85, 153, 255, 0.10); */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #aeaeae;\n  /* height: 40px; */\n  padding: 5px 20px;\n  position: relative;\n}\n\n.dynamic_sectionHeaderMoreOption {\n  position: absolute;\n  top: 75%;\n  right: 2%;\n  border-radius: 8px;\n  border: 0.6px solid #5599ff;\n  background-color: #f8fafc;\n  color: black;\n  text-align: center;\n  /* padding: 2rem; */\n  z-index: 1;\n}\n\n.dynamic_sectionHeaderMoreOption div:hover {\n  background-color: #dee7ff;\n  border-radius: 8px;\n}\n\n.dynamic_sectionHeader input {\n  background-color: transparent;\n  width: 40%;\n  border-radius: 8px;\n  border: 0.4px solid #b5d3ff;\n  padding: 8px 10px 8px 10px;\n  color: #aeaeae;\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_sectionContent {\n  padding: 10px 20px;\n  background-color: white;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.dynamic_container {\n  position: relative;\n}\n\n.dynamic_isPreviewing {\n  margin: 5px 0;\n}\n\n.dynamic_plusButton {\n  height: 16px;\n  width: 16px;\n  background-color: #cde1ff;\n  border-radius: 50%;\n  position: absolute;\n  top: 8px;\n  right: -15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dynamic_field {\n  border-radius: 8px;\n  border: 0.5px solid #dcdcdc;\n  background: #fff;\n  padding: 6px 15px;\n  color: #303030;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_createContainer {\n  width: 100%;\n  padding: 8px 50%;\n  border-radius: 8px;\n  border: 1px dashed #e9e9e9;\n  background-color: white;\n}\n\n.dynamic_createContainer div,\n.dynamic_containerPlus {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #e9e9e9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dynamic_createContainer:hover {\n  border-color: #5599ff;\n  cursor: pointer;\n}\n\n.dynamic_createContainer:hover div{\n  background-color: #5599ff;\n  border-radius: 50%;\n}\n\n.dynamic_selectedFields {\n  border-radius: 8px;\n  border: 0.5px solid #dcdcdc;\n  background: #fff;\n  padding: 10px;\n}\n\n.dynamic_fieldSearchInput {\n  border-radius: 8px;\n  padding: 8px 15px;\n  border: 0.4px solid #dcdcdc;\n  background: #fafafa;\n  color: #6c6c6c;\n\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_fieldSearchedValues {\n  padding: 8px 15px;\n  color: #6c6c6c;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_divider {\n  background: #f2f2f2;\n  height: 0.5px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.dynamic_fieldList {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  padding: 12px 15px;\n  border: 0.5px solid #dcdcdc;\n  background: #fff;\n  color: #303030;\n  margin-bottom: 10px;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_isCheckedFieldList {\n  border-color: #5599ff;\n}\n\n.dynamic_fieldType {\n  color: #c0c0c0;\n  font-family: Roboto;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.dynamic_switch {\n  margin-left: 20px;\n  margin-right: 60px;\n  position: relative;\n  display: inline-block;\n  width: 26px;\n  height: 14px;\n  padding: 0;\n}\n\n.dynamic_switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.dynamic_slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.dynamic_slider:before {\n  position: absolute;\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  left: 3px;\n  bottom: 4px;\n  top: 2px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .dynamic_slider {\n  background-color: #55e374;\n}\n\ninput:focus + .dynamic_slider {\n  box-shadow: 0 0 1px #55e374;\n}\n\ninput:checked + .dynamic_slider:before {\n  -webkit-transform: translateX(11px);\n  -ms-transform: translateX(11px);\n  transform: translateX(11px);\n}\n\n/* Rounded dynamic_sliders */\n.dynamic_slider.dynamic_round {\n  border-radius: 20px;\n}\n\n.dynamic_slider.dynamic_round:before {\n  border-radius: 50%;\n}\n\n.dynamic_checkbox {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  border-radius: 3px;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.dynamic_checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.dynamic_checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  border-radius: 3px;\n  background-color: #eee;\n}\n\n/* On mouse-over, add a grey background color */\n.dynamic_checkbox:hover input ~ .dynamic_checkmark {\n  background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n.dynamic_checkbox input:checked ~ .dynamic_checkmark {\n  background-color: #548dff;\n}\n\n/* Create the dynamic_checkmark/indicator (hidden when not checked) */\n.dynamic_checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the dynamic_checkmark when checked */\n.dynamic_checkbox input:checked ~ .dynamic_checkmark:after {\n  display: block;\n}\n\n/* Style the dynamic_checkmark/indicator */\n.dynamic_checkbox .dynamic_checkmark:after {\n  left: 5.5px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.dynamic_blueButton {\n  border-radius: 8px;\n  border: none;\n  background: #548dff;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n  padding: 11px 30px;\n  color: #fff;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.dynamic_blueButton:hover {\n  background-color: #4e82ec;\n}\n\n.dynamicDropDown_style {\n  \n}\n\n.dynamic_borderButton {\n  border-radius: 8px;\n  border: 1px solid #548dff;\n  background: #fff;\n  /* box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16); */\n  color: #548dff;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.dynamic_borderButton:hover {\n  background-color: #eff6ff;\n}\n\n.dynamic_createContainerLine {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dynamic_containerDivider,\n.dynamic_containerPlus {\n  transition: background-color 0.3s, border-color 0.3s;\n}\n\n.dynamic_containerDivider {\n  border: 1px dashed #e9e9e9;\n}\n\n.dynamic_createContainerLine:hover .dynamic_containerDivider,\n.dynamic_createContainerLine:hover .dynamic_containerPlus {\n  border-color: #5599ff;\n  background-color: #5599ff;\n}\n\n.dynamic_containerPlus:hover,\n.dynamic_createContainerLine:hover .dynamic_containerPlus {\n  background-color: #5599ff;\n}\n\n.dynamic_containerDivider:hover,\n.dynamic_createContainerLine:hover .dynamic_containerDivider {\n  border-color: #5599ff;\n}\n\n\n/* .dynamic_containerDivider {\n  border: 1px dashed #e9e9e9;\n} */\n\n.dynamic_leftOneDivider {\n  width: 51%;\n}\n\n.dynamic_rightOneDivider {\n  width: 49%;\n}\n\n/* .dynamic_containerDivider:hover, .dynamic_containerPlus:hover {\n  border-color: #5599ff;\n  background-color: #5599ff;\n  cursor: pointer;\n} */\n\n/* .dynamic_containerPlus:hover {\n  background-color: #5599ff;\n  cursor: pointer;\n} */\n\n.widthThirtyThree {\n  width: 33.33%;\n}\n\n.backgroundDisabled {\n  background-color: #e9e9e9;\n}\n\n.marginRightSixPx {\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
